import {  useState } from 'react';

import { ItemType } from './types';

interface HasId {
  id: number;
}

export const useMultiSelect = <T extends HasId>(items: T[]) => {
  const [selectedItems, setSelectedItems] = useState<T[]>([]);

  const handleRemoveItems = () => {
    const remainingItems = items.filter(
      (item) => !selectedItems.some((selected) => selected.id === item.id),
    );

    const itemIds = remainingItems.map((item) => item.id);
    return itemIds;
  };

  const handleClickAll = () => {
    if (selectedItems.length === items.length) {
      setSelectedItems([]);
    } else {
      setSelectedItems(items);
    }
  };

  const handleSelectItem = (item: T, checked: boolean) => {
    if (checked) {
      setSelectedItems((prev) => [...prev, item]);
    } else {
      setSelectedItems((prev) => prev.filter((prevItem) => prevItem.id !== item.id));
    }
  };

  const covertModelToItem = (model: any): ItemType => {
    return {
      id: model.id ?? 0,
      name: model.localizedName?.ko ?? model.name ?? '',
      imageUrl: model.images?.[0]?.url ?? '',
      desc: model ?? '',
      isActive: model.isActive ?? true,
    };
  };

  const unmount = () => {
    setSelectedItems([]);
  };

  return {
    selectedItems,
    handleRemoveItems,
    handleClickAll,
    handleSelectItem,
    covertModelToItem,
    unmount,
  };
};
